import { render } from "./OrderItem.vue?vue&type=template&id=46b52c3a&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=46b52c3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46b52c3a"

export default script